import {BrowserModule} from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {LayoutModule} from './layout/layout.module';
import {HttpAuthInterceptor} from './core/http-auth-interceptor';
import {GlobalErrorHandler} from './core/global-error-handler';
import {registerLocaleData} from '@angular/common';
import en from '@angular/common/locales/en';
import {CacheUrlProvider, LayoutService} from 'phd-akita-session';
import {SessionService} from './core/session.service';
import {HttpLoaderInterceptor} from './core/http-loader-interceptor';
import {UiService} from './shared/state/ui.service';
import {SsoRedirectModule} from './core/sso-redirect/sso-redirect.module';
import {FormlyModule} from '@ngx-formly/core';
import {FormlyNgZorroAntdModule} from '@ngx-formly/ng-zorro-antd';
import {en_US, NZ_I18N} from 'ng-zorro-antd/i18n';
import {NzMessageModule, NzMessageService} from 'ng-zorro-antd/message';
import {NzNotificationModule, NzNotificationService} from 'ng-zorro-antd/notification';
import {PdfViewerModule} from './shared/pdf-viewer/pdf-viewer.module';

registerLocaleData(en);

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    LayoutModule,
    SsoRedirectModule,
    FormlyModule.forRoot(),
    FormlyNgZorroAntdModule,
    NzNotificationModule,
    PdfViewerModule,
    NzMessageModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpAuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpLoaderInterceptor,
      multi: true
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
      deps: [SessionService, UiService]
    },
    {provide: CacheUrlProvider, useExisting: LayoutService},
    {provide: NZ_I18N, useValue: en_US},
    NzMessageService,
    NzNotificationService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
